import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6 lg:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <h3 className="font-heading text-accent-200 text-lg mb-3">
              Carol L Berry
            </h3>
            <p className="text-background-100/60 font-body text-sm leading-relaxed mb-4">
              Real Estate Professional helping homeowners sell with confidence,
              knowledge and personal attention.
            </p>
            <Link
              to="/home-valuation"
              className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-4 py-2 rounded-md text-sm font-body font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              Request a Home Valuation
            </Link>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-body text-accent-300 text-xs tracking-widest uppercase mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Sell Your Home', href: '/sell-your-home' },
                { label: 'Home Valuation', href: '/home-valuation' },
                { label: 'About Carol', href: '/about' },
                { label: 'Seller Resources', href: '/seller-resources' },
                { label: 'Blog', href: '/blog' },
                { label: 'Contact', href: '/contact' },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-background-100/60 font-body text-sm hover:text-accent-300 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Blog */}
          <div>
            <h4 className="font-body text-accent-300 text-xs tracking-widest uppercase mb-4">
              Seller Advice
            </h4>
            <ul className="space-y-2.5">
              {[
                '3 Signs You Should Sell',
                'Sell Your Home When You Retire',
                'Best Way To Sell A House',
              ].map((title) => (
                <li key={title}>
                  <Link
                    to="/blog"
                    className="text-background-100/60 font-body text-sm hover:text-accent-300 transition-colors"
                  >
                    {title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-body text-accent-300 text-xs tracking-widest uppercase mb-4">
              Get In Touch
            </h4>
            <div className="space-y-3">
              <a
                href="tel:+19734934311"
                className="flex items-center gap-2 text-background-100/60 font-body text-sm hover:text-accent-300 transition-colors"
              >
                <i className="ri-phone-line text-accent-500" />
                +1 (973) 493-4311
              </a>
              <a
                href="mailto:CarolBerry.Realtor@gmail.com"
                className="flex items-center gap-2 text-background-100/60 font-body text-sm hover:text-accent-300 transition-colors"
              >
                <i className="ri-mail-line text-accent-500" />
                CarolBerry.Realtor@gmail.com
              </a>
              <Link
                to="/contact"
                className="flex items-center gap-2 text-background-100/60 font-body text-sm hover:text-accent-300 transition-colors"
              >
                <i className="ri-chat-3-line text-accent-500" />
                Send a Message
              </Link>
              <Link
                to="/home-valuation"
                className="flex items-center gap-2 text-background-100/60 font-body text-sm hover:text-accent-300 transition-colors"
              >
                <i className="ri-home-4-line text-accent-500" />
                Free Home Valuation
              </Link>
              <a
                href="http://carolberry.C21.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-background-100/60 font-body text-sm hover:text-accent-300 transition-colors"
              >
                <i className="ri-building-line text-accent-500" />
                Century 21 Cedarcrest Realty, Inc.
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Legal & Disclosure Bar */}
      <div className="border-t border-foreground-800">
        <div className="max-w-[1100px] mx-auto px-4 md:px-6 lg:px-10 py-6">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <p className="text-foreground-500 font-body text-xs leading-relaxed max-w-[700px]">
              Carol L Berry is a real estate professional affiliated with Century 21 Cedarcrest Realty, Inc.
              All information provided on this website is for informational purposes only and does not constitute
              legal, financial or professional advice. REALTOR is a registered trademark of the
              National Association of Realtors. This website practices equal housing opportunity
              and complies with all applicable fair housing laws.
            </p>
            <div className="flex items-center gap-4 flex-shrink-0">
              <a
                href="http://carolberry.C21.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground-500 font-body text-xs hover:text-accent-300 transition-colors"
              >
                Century 21 Cedarcrest Realty, Inc.
              </a>
              <span className="text-foreground-700">|</span>
              <Link
                to="/contact"
                className="text-foreground-500 font-body text-xs hover:text-accent-300 transition-colors"
              >
                Contact
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-foreground-800">
        <div className="max-w-[1100px] mx-auto px-4 md:px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 font-body text-xs">
            &copy; {new Date().getFullYear()} Carol L Berry. All rights reserved.
          </p>
          <p className="text-foreground-600 font-body text-xs">
            Real Estate Professional &middot; Century 21 Cedarcrest Realty, Inc.
          </p>
        </div>
      </div>
    </footer>
  );
}